import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../../constants';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../../models';
import { UtilService } from '../../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class LoginPostWithRememberUserService {
  loginAuthRememberMeHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.rememberDevice+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: UtilService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginPostWithRememberUser = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    userInputFields: ILoginUserNamePasswordInput
  ): Observable<LoginAuthWithCredentialsResponse> => {
    const rememberMe =
      userInputFields?.rememberMe === 'Y' ||
      userInputFields?.persistentLogin === 'Y'
        ? true
        : false;

    const payload: PostWithCredentials = {
      rememberUser: rememberMe
    };

    const getLoginPostWithRememberUserUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginPostWithRememberUserUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginPostWithRememberUserUrl
      }
    ];

    return new ApiBuilder<
      PostWithCredentials,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginPostWithRememberUserUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.loginAuthRememberMeHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_POST_WITH_REMEMBER_USER_SERVICE')
      .withCredentials(true)
      .create();
  };
}
